import { STATUS_STYLES } from "../../lib/constants";

export const StatusBadge = ({ status, className = "" }) => (
  <span
    data-testid={`status-badge-${status}`}
    className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded border text-[11px] font-semibold font-mono-cc uppercase tracking-[0.08em] whitespace-nowrap ${STATUS_STYLES[status] || "bg-slate-500/10 text-slate-500 border-slate-500/30"} ${className}`}
  >
    <span className="w-1.5 h-1.5 rounded-full bg-current pulse-dot" />
    {(status || "").replace(/_/g, " ")}
  </span>
);
